import {TabsTemplate} from 'components/Common/Tabs/Template';
import {withProps} from 'recompose';

export default withProps({
  tabs: {
    index: '使用者管理',
    recover: '已刪除名單',
  },
})(TabsTemplate);
